import {
  FormPageInputItem,
  FormPageInputItemText,
  FormPageInputItemTextAdditionalText,
  FormPageInputItemTextMultiLine,
  FormPageInputItemTextName,
  FormPageInputItemTextSingleLine,
  FormPageInputItemTextTel,
  FormPageInputItemTextZipCode,
  FormPageInputItemTextZipCodeWithoutHyphen,
  INPUT_ITEM_TYPE,
  TextProperty,
  TEXT_PROPERTY_INPUT_TYPE,
} from 'shared';

const handleSingleLine = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemTextSingleLine => {
  if (formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.textSingleLine) {
    return {
      inputItemType: INPUT_ITEM_TYPE.textSingleLine,
      text: formPageInputItem.text || '',
    };
  }
  return {
    inputItemType: INPUT_ITEM_TYPE.textSingleLine,
    text: '',
  };
};

const handleName = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemTextName => {
  if (formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.textName) {
    return {
      inputItemType: INPUT_ITEM_TYPE.textName,
      firstName: formPageInputItem.firstName || '',
      lastName: formPageInputItem.lastName || '',
    };
  }
  return {
    inputItemType: INPUT_ITEM_TYPE.textName,
    firstName: '',
    lastName: '',
  };
};

const handleTel = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemTextTel => {
  if (formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.textTel) {
    return {
      inputItemType: INPUT_ITEM_TYPE.textTel,
      first: formPageInputItem.first || '',
      second: formPageInputItem.second || '',
      third: formPageInputItem.third || '',
    };
  }
  return {
    inputItemType: INPUT_ITEM_TYPE.textTel,
    first: '',
    second: '',
    third: '',
  };
};

const handleZipCode = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemTextZipCode => {
  if (formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.textZipCode) {
    return {
      inputItemType: INPUT_ITEM_TYPE.textZipCode,
      first: formPageInputItem.first || '',
      second: formPageInputItem.second || '',
    };
  }
  return {
    inputItemType: INPUT_ITEM_TYPE.textZipCode,
    first: '',
    second: '',
  };
};

const handleZipCodeWithoutHyphen = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemTextZipCodeWithoutHyphen => {
  if (
    formPageInputItem?.inputItemType ===
    INPUT_ITEM_TYPE.textZipCodeWithoutHyphen
  ) {
    return {
      inputItemType: INPUT_ITEM_TYPE.textZipCodeWithoutHyphen,
      zipCode: formPageInputItem.zipCode || '',
    };
  }
  return {
    inputItemType: INPUT_ITEM_TYPE.textZipCodeWithoutHyphen,
    zipCode: '',
  };
};

const handleAdditionalText = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemTextAdditionalText => {
  if (formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.textAdditionalText) {
    return {
      inputItemType: INPUT_ITEM_TYPE.textAdditionalText,
      text: formPageInputItem.text || '',
    };
  }
  return {
    inputItemType: INPUT_ITEM_TYPE.textAdditionalText,
    text: '',
  };
};

const handleMultiLine = (
  formPageInputItem?: FormPageInputItem
): FormPageInputItemTextMultiLine => {
  if (formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.textMultiLine) {
    return {
      inputItemType: INPUT_ITEM_TYPE.textMultiLine,
      text: formPageInputItem.text || '',
    };
  }
  return {
    inputItemType: INPUT_ITEM_TYPE.textMultiLine,
    text: '',
  };
};

export const convertTextInitialValue = (
  property: TextProperty,
  formPageInputItem?: FormPageInputItem
): FormPageInputItemText => {
  const {
    singleLine,
    tel,
    name,
    zipCode,
    zipCodeWithoutHyphen,
    additionalText,
    multiLine,
  } = TEXT_PROPERTY_INPUT_TYPE;
  switch (property.inputFormat.inputType) {
    case singleLine:
      return handleSingleLine(formPageInputItem);
    case tel:
      return handleTel(formPageInputItem);
    case name:
      return handleName(formPageInputItem);
    case zipCode:
      return handleZipCode(formPageInputItem);
    case zipCodeWithoutHyphen:
      return handleZipCodeWithoutHyphen(formPageInputItem);
    case additionalText:
      return handleAdditionalText(formPageInputItem);
    case multiLine:
      return handleMultiLine(formPageInputItem);
  }
};
